import { Badge, Box } from "@mui/material";
import { useSelector } from "react-redux";

import FlagIcon from "../../../assets/Message/FlagIcon";
import timeSince from "../../../helper/timeSince";
import { Notification } from "../../../interfaces/Notification";
import { theme } from "../../../mui-customs/Theme";
import { RootState } from "../../../redux/store";
import Typography from "../../Typography";

interface Props {
  notification: Notification;
  onClick: (notification: Notification) => void;
  showSelected?: boolean;
}

const NotificationCard = ({
  notification,
  onClick,
  showSelected = false,
}: Props) => {
  const { selectedNotification } = useSelector(
    (state: RootState) => state.notifications
  );
  return (
    <Box
      onClick={() => onClick(notification)}
      sx={{
        width: "100%",
        display: "flex",
        gap: "15px",
        py: 2,
        px: { md: 2 },
        cursor: "pointer",
        backgroundColor:
          showSelected && selectedNotification?.id === notification.id
            ? theme.whiteBg.WBG3
            : theme.whiteBg.WBG1,
        alignItems: "center",
      }}
    >
      <Box sx={{ minHeight: "40px", minWidth: "40px" }}>
        <Badge variant="dot" color="error" invisible={notification.isRead}>
          <FlagIcon width={40} height={40} />
        </Badge>
      </Box>
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            color: theme.grey1[400],
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography
            variant="title1"
            overflow={"hidden"}
            textOverflow={"ellipsis"}
            sx={{
              color: `${theme.black[800]} !important`,
              fontWeight: "600 !important",
            }}
          >
            {notification.title}
          </Typography>

          <Typography variant="verySmall2">
            {timeSince(new Date(notification.sentTime))}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationCard;
